












import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Textbox from "@/components/Textbox.vue";

@Component(
{
	components: {
		Textbox
	}
})

export default class TranslationsKeyValuePairRow extends Vue
{
	@Prop() translationsKey!: string;
	@Prop() translationsValue!: string;
	@Prop() translationsValueEnUs!: string;
	@Prop() translationsLocale!: string;

	data()
	{
		return {
			model: {
				translationsValue: this.translationsValue,
				translationsValueEnUs: this.translationsValueEnUs,
				translationsLocale: this.translationsLocale
			}
		};
	}

	onValueChanged(s: string)
	{
		console.log("TranslationsKeyValuePairRow onValueChanged()", s);

		(this as any).model.translationsValue = s;

		this.$emit("update:translationsValue", (this as any).model.translationsValue);
		this.$emit("translationsValueChanged", (this as any).model.translationsValue);
	}
}
